import { useTranslation } from "react-i18next";
import { Button, Grid, Typography } from "@material-ui/core";
import mena_fccg_logo_white from "../../assets/images/mena-fccg-logo-white.png";
import fight_financial_crimes_white from "../../assets/images/fight-financial-crimes-white.png";

// Icons
import LanguageIcon from "@material-ui/icons/Language";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

// Services
import sessionStorage from "../../services/storage/SessionStorage";

// Styles
import NavigationBarStyle from "../../assets/styles/materialUI/questionnaire/NavigationBarStyle";

// Providers
import { useLanguage } from "../../contexts/languageContext";

const NavigationBar = ({ setError, setMessage }) => {
	const naviationBarclasses = NavigationBarStyle();
	const { t } = useTranslation();
	const { language, direction, switchLanguage } = useLanguage();

	const onLogout = () => {
		sessionStorage.clear();
		window.location.reload();
	};

	const HandleSwitchLanguage = () => {
		setMessage("common.language.changeLanguage");
		switchLanguage();
		setTimeout(() => {
			setMessage(null);
		}, 2000);
	};

	return (
		<div dir={direction}>
			<Grid className={naviationBarclasses.navbar}>
				<img src={mena_fccg_logo_white} className={naviationBarclasses.headerLogoLeft} alt="MENA FCCG" />
				<Typography className={naviationBarclasses.headerText}>{t("navbar.title")}</Typography>
				<img
					src={fight_financial_crimes_white}
					className={naviationBarclasses.headerLogoRight}
					alt="Fight Financial Crimes"
				/>
			</Grid>
			<Grid dir="rtl">
				{sessionStorage.getAuthObj() && (
					<Button onClick={onLogout} className={naviationBarclasses.logoutButton}>
						<ExitToAppIcon />
						<Typography className={naviationBarclasses.logoutLabel}>{t("navbar.logout")}</Typography>
					</Button>
				)}
				<Button onClick={HandleSwitchLanguage} className={naviationBarclasses.logoutButton}>
					<LanguageIcon />
					<Typography className={naviationBarclasses.logoutLabel}>
						{language === "ar" ? t("common.language.english") : t("common.language.arabic")}
					</Typography>
				</Button>
			</Grid>
		</div>
	);
};

export default NavigationBar;
